<template>
	<report-page
		:start-date="false"
		:end-date="false"
		get-url="/bo/report/customerservice/claimlimit"
		title="Claim Limit Report"
		export-filename="claim_limit"
	>
		<template #item.policyNumber=" { item }">
			<a :href="item.policyNumber">
				{{ item.policyNumber }}
			</a>
		</template>
	</report-page>
</template>

<script>
export default {
	name: 'ClaimLimitReport'
};
</script>
